import { useState, useEffect } from "react";
import ItemDetail from "./ItemDetail";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { db } from "../FireBase";
import { doc, getDoc, collection } from "firebase/firestore";

const ItemDetailContainer = () => {

    const [producto, setProducto] = useState([]);

    const [loading, setLoading] = useState(true);

    const { id, type } = useParams();
    useEffect(() => {

if (type === "simples") {
    const productCollection = collection(db, "simples")
        const documentProduct = doc(productCollection, id)
        const docs = getDoc(documentProduct)
        docs
            .then(respuesta => {
                const product = {
                    id: respuesta.id,
                    ...respuesta.data()
                }
                setProducto(product)
                console.log(respuesta)
            })
            .catch(() => {
               toast.error('Error al cargar el Producto')
            })
            .finally(() => {
                setLoading(false)
            })
} else if (type === "torta"){
    const tortasCollection = collection(db, "tortas")
    const tortasProduct = doc(tortasCollection, id)
    const tortas = getDoc(tortasProduct)
    tortas
    .then(respuesta => {
        const product = {
            id: respuesta.id,
            ...respuesta.data()
        }
        setProducto(product)
    })
    .catch(() => {
       toast.error('Error al cargar el Producto')
    })
    .finally(() => {
        setLoading(false)
    })
}else if (type === "especiales"){
    const especialesCollection = collection(db, "triplesespeciales")
    const  especialesProduct = doc(especialesCollection, id)
    const  especiales = getDoc(especialesProduct)
    especiales
    .then(respuesta => {
        const product = {
            id: respuesta.id,
            ...respuesta.data()
        }
        setProducto(product)
    })
    .catch(() => {
       toast.error('Error al cargar el Producto')
    })
    .finally(() => {
        setLoading(false)
    })
}else if (type === "chipa"){
    const chipaCollection = collection(db, "chipa")
    const  chipaProduct = doc(chipaCollection, id)
    const  chipa = getDoc(chipaProduct)
    chipa
    .then(respuesta => {
        const product = {
            id: respuesta.id,
            ...respuesta.data()
        }
        setProducto(product)
    })
    .catch(() => {
       toast.error('Error al cargar el Producto')
    })
    .finally(() => {
        setLoading(false)
    })
}else if (type === "surtidos"){
    const surtidosCollection = collection(db, "triplessurtidos")
    const  surtidosProduct = doc(surtidosCollection, id)
    const  surtidos = getDoc(surtidosProduct)
    surtidos
    .then(respuesta => {
        const product = {
            id: respuesta.id,
            ...respuesta.data()
        }
        setProducto(product)
    })
    .catch(() => {
       toast.error('Error al cargar el Producto')
    })
    .finally(() => {
        setLoading(false)
    })
}

        

            
            

      
    }, [id])

    console.log("producto",producto)

    return (
        <ItemDetail productos={producto} idd={id} />
    )
}

export default ItemDetailContainer;